import {
  FILE_UPLOAD_DOCUMENT_ALLOWED_FORMATS,
  FILE_UPLOAD_DOCUMENT_TYPE_TEXT,
  FILE_UPLOAD_IMAGE_ALLOWED_FORMATS,
  FILE_UPLOAD_IMAGE_FILE_TYPE_TEXT,
  INTAKE_FORM_TYPE_PREFERRED_PHARMACY_TEXT,
} from '../../../../../utils/constants'

export const text = {
  EDIT_INTAKE: 'Edit intake',
  EMAIL: 'Email',
  STATEMENT: 'Statement',
  TEXT_BOX: 'Text box',
  FILE_UPLOAD: 'File upload',
  MULTIPLE_CHOICE: 'Multiple choice',
  SINGLE_CONDITION: 'Single select w/ Follow up',
  HEIGHT_WEIGHT: 'Height & Weight',
  PREFERRED_PHARMACY: INTAKE_FORM_TYPE_PREFERRED_PHARMACY_TEXT,
} as const

export const styles = {
  EDIT_BUTTON_STYLE: {
    width: 200,
    height: 40,
  },
} as const

export type FileFormatOption = {
  value: string
  allowedFormats: readonly string[]
  isActive: boolean
}

const NEW_INTAKE_FORM_FILE_UPLOADS_TYPES = [
  {
    name: FILE_UPLOAD_DOCUMENT_TYPE_TEXT,
    allowedFormats: FILE_UPLOAD_DOCUMENT_ALLOWED_FORMATS,
  },
  {
    name: FILE_UPLOAD_IMAGE_FILE_TYPE_TEXT,
    allowedFormats: FILE_UPLOAD_IMAGE_ALLOWED_FORMATS,
  },
] as const

export const multiSelectFileFormatOptions: FileFormatOption[] = NEW_INTAKE_FORM_FILE_UPLOADS_TYPES.map((t) => ({
  value: t.name,
  allowedFormats: t.allowedFormats,
  isActive: false,
}))

export function getFileFormats(fileTypes: unknown): FileFormatOption[] {
  if (!fileTypes) return multiSelectFileFormatOptions
  const types = Array.isArray(fileTypes) ? fileTypes : []
  return NEW_INTAKE_FORM_FILE_UPLOADS_TYPES.map((t) => ({
    value: t.name,
    allowedFormats: t.allowedFormats,
    isActive:
      (t.name === FILE_UPLOAD_DOCUMENT_TYPE_TEXT && types.includes('document')) ||
      (t.name === FILE_UPLOAD_IMAGE_FILE_TYPE_TEXT && types.includes('image')),
  }))
}

export function getIntakeFormType(type: unknown): string {
  switch (type) {
    case 'email':
      return text.EMAIL
    case 'file':
      return text.FILE_UPLOAD
    case 'textbox':
      return text.TEXT_BOX
    case 'statement':
      return text.STATEMENT
    case 'option':
      return text.MULTIPLE_CHOICE
    case 'condition':
      return text.SINGLE_CONDITION
    case 'bodymeasurement':
      return text.HEIGHT_WEIGHT
    case 'pharmacyselection':
      return text.PREFERRED_PHARMACY
    default:
      return ''
  }
}
